<template>
	<dms-select-grid v-bind="{ labelKey: 'TEXT', disabled, validationOff, span, noLabelAlign }" @clear="clearClick" @openGrid="openPracovniPoziceGrid()">
		<dms-input-remote-search ref="nrInput" :disabled="isDisabled" :value.sync="Text" label-key="TEXT" :show-label="false" :wrapp="false"
			class="input-with-select" validation-off :autofocus="autofocus" :data-fetch="apiDataFetch"
			:schema-fetch="apiSchemaFetch" :filter="pracovniPoziceFilter" :query-length="3"
			search-field-name="TEXT" @input="$emit('input')"
			@selected="selected" @clear="clear" />
	</dms-select-grid>
</template>

<script>
import _ from 'lodash';
import { openSelectList } from '@/main/router/routerPath';
import { PPNR } from '@/modules/ciselnik/dilenske/constants';
import { NAME as PRACOVNI_POZICE } from '@/modules/ciselnik/dilenske/pracovniPozice/constants';

import { apiProvider } from '@/modules/ciselnik/dilenske/pracovniPozice/api';

import { BaseSelect, selectName } from '#components/baseSelect';

export default BaseSelect.extend({
	name: selectName(PPNR),
	props: {
		showPpButton: { type: Boolean, default: false },
		pracovniPoziceFilter: { type: Object, default: () => {} },
		pracovniPoziceCheck: { type: Function, default: () => {} },
		ppnr: { type: String },
		isPpButtonDisabled: { type: Boolean, default: false },
	},
	data() {
		return {
			apiProvider,
			emptyObject: {
				ppNr: null,
				popis: null,
			},
		};
	},
	computed: {
		Text: {
			get() {
				return this.ppnr;
			},
			set(val) {
				this.$emit('update:ppnr', val);
			},
		},
	},
	methods: {
		focusInput() {
			this.$refs.nrInput.focus();
		},

		async openPracovniPoziceGrid() {
			const result = await this.pracovniPoziceCheck();
			if (result) {
				await openSelectList(
					PRACOVNI_POZICE,
					{
						afterRowSelection: this.selected,
						filter: this.pracovniPoziceFilter,
						showFilter: false,
					},
				);
				this.setPageManagerMapper();
			}
		},
		getPopis(data) {
			if (_.has(data, this.textFieldName)) {
				return data[this.textFieldName];
			}
			if (_.has(data, 'X_POPIS')) {
				return data.X_POPIS;
			}
			return null;
		},

		dbToBaseMapper(data) {
			if (_.has(data, 'PP_NR')) {
				return {
					zaznamId: data.ZAZNAM_ID,
					tablPozice: data.X_TABLPOZICE,
					popis: this.getPopis(data),
					casJdnPoc: data.CAS_JDN_POC,
					lakJdnPoc: data.LAK_JDN_POC,
					zarmobilPznZkt: data.X_ZARMOBIL_PZN_ZKT,
					ppNr: data.PP_NR,
					editPrp: data.EDIT_PRP,
					selectComplete: true,
					pcPevna: data.PC_PEVNA,
					pcSpec: data.PC_SPEC,
					ppDesc: data.PP_DESC,
				};
			}
			return {
				ppNr: data.PP_SERVIS_NR || (this.ppnr ? `${this.ppnr}${data.PP_DRUH}` : null),
			};
		},
	},
});
</script>

<style scoped>
.pracovni-pozice-btn {
	margin-left: 5px;
}
</style>
